import React from "react";
import { Badge } from "..";
import { Tooltip } from "react-tooltip";
import { APPROVAL_COPY, IN_POLICY_APPROVAL, resolveFarePolicy } from "./status";

function safeTooltipId(value) {
	const cleaned = String(value || "fare").replace(/[^a-zA-Z0-9_-]/g, "");
	return cleaned.slice(-48) || "fare";
}

function OutOfPolicyBadge({ violations = [], withinLimits, approvalRequired, approvalWhen, tooltipId = "ask-approval", split = false }) {
	if (!split) {
		const id = safeTooltipId(tooltipId);
		return (
			<div data-tooltip-id={id} data-tooltip-content={violations.join(", ")}>
				<Badge variant="danger" className="mb-2">
					Out of Policy
				</Badge>
				<Tooltip id={id} className="text-xs" />
			</div>
		);
	}

	const { limitsPassed, needsApproval, knowsApproval, approvalState, limitViolations } = resolveFarePolicy({
		withinLimits,
		approvalRequired,
		approvalWhen,
		violations,
	});
	const policyTip = limitsPassed ? "Inside policy limits" : limitViolations.join(", ") || "Outside policy limits";
	const approvalTip =
		approvalState === "blocked"
			? "No approval rule covers this fare. Your policy does not allow this booking."
			: needsApproval
				? APPROVAL_COPY[approvalWhen] || IN_POLICY_APPROVAL
				: "No approval is required";
	const approvalLabel = approvalState === "blocked" ? "Not allowed" : needsApproval ? "Approval required" : "No approval";
	const approvalVariant = approvalState === "blocked" ? "danger" : needsApproval ? "warning" : "";
	const id = safeTooltipId(tooltipId);

	return (
		<div className="flex flex-wrap items-center justify-center gap-1 mb-2">
			<span data-tooltip-id={`${id}-policy`} data-tooltip-content={policyTip}>
				<Badge variant={limitsPassed ? "success" : "danger"}>{limitsPassed ? "In policy" : "Out of policy"}</Badge>
			</span>
			{knowsApproval && (
				<span data-tooltip-id={`${id}-approval`} data-tooltip-content={approvalTip}>
					<Badge variant={approvalVariant}>{approvalLabel}</Badge>
				</span>
			)}
			<Tooltip id={`${id}-policy`} className="text-xs" />
			{knowsApproval && <Tooltip id={`${id}-approval`} className="text-xs" />}
		</div>
	);
}

export default OutOfPolicyBadge;
